
import { defineComponent, SetupContext, computed } from "vue";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "FridgeDetailsTabsItem",
  props: {
    /** 添字 */
    index: {
      type: Number,
      required: true
    },
    /** 表示する文字列 */
    title: {
      type: String,
      required: true
    },
    /** 選択中 */
    selected: {
      type: Boolean,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const selectItem = () => {
      if (props.selected) {
        return;
      }
      context.emit("select-tab-index", props.index)
    }
    const indicatorStyle = computed(() => {
      if (props.selected) {
        NativeClient.sendDebugLog("FridgeDetailsTabItem indicatorStyle active");
        return { backgroundColor: "var(--main-theme-color)" };
      }
      return { backgroundColor: "transparent" };
    });
    return {
      selectItem,
      indicatorStyle
    };
}
});
